<template>
	<BaseStatusForm
		:propPageID="pageID"/>
</template>

<script>
	import BaseStatusForm from '../../components/status/Form.vue';

	export default {
		components: {
			BaseStatusForm
		},
		data() {
			return {
				pageID: 'global_statuses',
			}
		},
	}
</script>
